export class SettingFiles {
    multiple: Boolean;
    title: String;
    type: String;
    constructor(public _title: string, public _multiple: boolean, public _type: string) {
        this.title = _title;
        this.multiple = _multiple;
        this.type = _type;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/dominio/settingFiles.ts